import { defineMessages } from 'react-intl-next';

export const HintPopupMessages = defineMessages({
	MoreInfoIconLabel: {
		id: `eoc.form.field.hint-popup.more-info-icon-label`,
		defaultMessage: 'More about {fieldName}',
		description: "The label for the 'More info' icon in the hint popup",
	},
});
